"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoidZoneAbilityHandler = exports.VoidZoneActorAbilityFactory = exports.VoidZoneAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const core_3 = require("../../core/event-handlers/core");
class VoidZoneAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.VoidZone;
        this.__typeName = "VoidZone";
    }
}
exports.VoidZoneAbilityArgs = VoidZoneAbilityArgs;
let VoidZoneActorAbilityFactory = class VoidZoneActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("VoidZone", "Self", 5);
    }
};
VoidZoneActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("VoidZone")
], VoidZoneActorAbilityFactory);
exports.VoidZoneActorAbilityFactory = VoidZoneActorAbilityFactory;
let VoidZoneAbilityHandler = class VoidZoneAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                container.removeDebuffs({
                    sequence,
                    removerId: ability.invokerId,
                    targets: [{
                            targetId: ability.invokerId,
                            includeSupernatural: false,
                            onDebuffsRemoved(sequence, effectIds) {
                                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(ability.invokerId, "feet"), "EngulfingDarkness"));
                                const effectId = container.applyBuff({
                                    sequence,
                                    creatorId: ability.invokerId,
                                    targetId: ability.invokerId,
                                    duration: Duration_1.Duration.Permanent,
                                    effect: new core_2.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.CriticalStrikeChance, 10 * effectIds.length)
                                });
                                container.registerEventHandler(ability.invokerId, EventType_1.EventType.Attack, Schedule_1.Schedule.Once(), new core_3.CancelEffectsEventHandlerArgs([effectId]));
                            },
                        }]
                });
            },
        });
    }
};
VoidZoneAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.VoidZone)
], VoidZoneAbilityHandler);
exports.VoidZoneAbilityHandler = VoidZoneAbilityHandler;
